import 'bootstrap/dist/css/bootstrap.min.css';
// import logo from './logo.svg';
import './App.css';
import Navbar from "./Components/Navbar1";
import Home from "./Components/Home";
import Blogs from "./Components/Blogs";
import About from "./Components/About";
import Contact from "./Components/Contact";
// import Plans from "./Components/Plans";
import Plans from "./Components/PlansV1C";
import NutritionProgram from './Components/NutritionProgram';
import Consultation from './Components/Consultation';
import DietPlan from './Components/DietPlan';
import PCOD from './Components/PCOD';
import Bride2Be from './Components/Bride2Be';
import Footer from "./Components/Footer";
import { BrowserRouter as Router, Route, Routes } from 'react-router';
import ScrollTop from './Components/ScrollTop';

function App() {
  return (
    <Router>
      <ScrollTop/>
      <Navbar/>
      <Routes>        
          <Route path="/" element={<Home />} />
          <Route path="/Blogs" element={<Blogs />} />
          <Route path="/About" element={<About />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Plans" element={<Plans />} />
          <Route path="/plans/nutritionprogram" element={<NutritionProgram />} />
          <Route path="/plans/consultation" element={<Consultation />} />
          <Route path="/plans/dietplan" element={<DietPlan />} />
          <Route path="/plans/pcod" element={<PCOD />} />
          <Route path="/plans/bride2be" element={<Bride2Be />} />
      </Routes> 
      <Footer/>   
   </Router>
  );
}

export default App;
